import React from "react";
import { Text, Xs, withQuery } from "components/common";
import moment from "moment";
import { convertToShortDate } from "utils";
import { USER_CREDIT_SCORE_QUERY } from "components/Pages/Boost/mutations";
import CreditScoreChart from "./CreditScoreChart";


const QUERY_OPTIONS = { variables: { limit: 2, order: "desc" } };

const CreditScore = ({
  className,
  data: {
    getUserCreditScore: { credit_scores }
  }
}) => {
  const latest_credit_score = credit_scores[0];
  const previous_credit_score = credit_scores[1];

  const current_score = latest_credit_score?.credit_score || null; // need null for chart
  let previous_score;

  let previous_updated_date_formatted;
  let score_changed_since_label;

  let score_difference_label = "";
  let score_difference;
  let score_difference_color;

  const next_update_date = moment().add(1, "months");
  const next_update_date_formatted = next_update_date.format("MMMM YYYY");
  const next_update_label = "Next Update: ";

  if (current_score) {
    previous_score = previous_credit_score?.credit_score;
  }

  if (previous_score) {
    score_difference = current_score - previous_score;
    let points_label = "points";
    if (score_difference === 1 || score_difference === -1) {
      points_label = "point";
    }
    score_difference_label =
      score_difference >= 0
        ? `+${score_difference} ${points_label}`
        : `${score_difference} ${points_label}`;
    score_difference_color =
      score_difference > 0 ? `text-green-primary` : `text-gray-primary`;

    previous_updated_date_formatted = previous_credit_score.date_pulled_at
      ? convertToShortDate(previous_credit_score.date_pulled_at)
      : "last month";
    score_changed_since_label = `Since ${previous_updated_date_formatted}`;
  }

  return (
    <div className={`${className} w-2/5`}>
      <div className="flex rounded-sm common-container h-auto min-h-full overflow-hidden">
        <div className="flex flex-col items-center text-center justify-center w-1/2 md:pr-5 pr-2">
          <Text title>Your Credit Score</Text>
          <Text className={`text-xl md:text-3xl ${score_difference_color}`}>
            {score_difference_label}
          </Text>
          <Text className="text-s">{score_changed_since_label}</Text>
          <Text className="text-xs pt-2">
            <span className="font-bold">{next_update_label}</span>
            <Xs to="md">
              <br />
            </Xs>
            {next_update_date_formatted}
          </Text>
        </div>
        <div className="flex flex-col w-1/2 text-center items-center justify-center scale-75">
          <CreditScoreChart creditScore={latest_credit_score}/>
        </div>
      </div>
    </div>
  );
};

export default withQuery(USER_CREDIT_SCORE_QUERY, QUERY_OPTIONS)(CreditScore);
